var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"pt-3",attrs:{"app":"","clipped":"","color":"grey lighten-5","value":_vm.$store.state.showDrawer},on:{"update:value":function($event){return _vm.$set(_vm.$store.state, "showDrawer", $event)}}},[(_vm.$vuetify.breakpoint.mobile)?_c('sf-nav-list',{attrs:{"title":"Main Menu","items":_vm.mobile_links}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }